import { h } from "omi";

import { IconProps } from "@/wc/components";

export function FacebookIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" width={width} height={height}>
      <g clip-path="url(#a)">
        <path
          fill="currentColor"
          d="M24.7998 12.5c0-6.62742-5.3726-12-12-12C6.17238.5.799805 5.87258.799805 12.5c0 5.9895 4.388205 10.954 10.124995 11.8542v-8.3854H7.87793V12.5h3.04687V9.85625c0-3.0075 1.7916-4.66875 4.5326-4.66875 1.3125 0 2.6862.23438 2.6862.23438V8.375h-1.5132c-1.4906 0-1.9556.92508-1.9556 1.875v2.25h3.3281l-.532 3.4688h-2.7961v8.3854c5.7368-.9002 10.125-5.8647 10.125-11.8542Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" transform="translate(.799805 .5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
